// extracted by mini-css-extract-plugin
export default {"Dialog":"dialog_Dialog__0onZw","Open":"dialog_Open__ldGRE","Box":"dialog_Box__WwyTu","ButtonWrapper":"dialog_ButtonWrapper__KG2iI"};